import React from "react";
import Row from "../../../../../components/Row";
import Col from "../../../../../components/Col";
import ModernDatePicker from "src/components/SharedComponents/ModernDatePicker/ModernDatePicker";

interface DateRange {
  startDate: Date | null;
  endDate: Date | null;
}

interface DateRangeFiltersProps {
  dates: DateRange;
  setDates: (next: DateRange) => void;
}

export const DateRangeFilters = ({
  dates,
  setDates,
}: DateRangeFiltersProps) => (
  <Row style={{ marginBottom: "15px" }}>
    <Col md={6} xs={6}>
      <ModernDatePicker
        label="Start Date"
        labelAlign="left"
        value={dates.startDate}
        onChange={(date: Date | null) => setDates({ ...dates, startDate: date })}
      />
    </Col>
    <Col md={6} xs={6}>
      <ModernDatePicker
        label="End Date"
        labelAlign="left"
        value={dates.endDate}
        onChange={(date: Date | null) => setDates({ ...dates, endDate: date })}
      />
    </Col>
  </Row>
);
